import HttpService from "./http.service";

class DashboardService extends HttpService {
    list = (params) => this.gets("suppliers/dashboard", params);

    create = (data) => this.post("suppliers/job", data);

    show = (data) => this.get("suppliers/dashboard", data);

    update = (data, params) => this.put("suppliers/job", data, params);
}

export default new DashboardService();
